module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Goldingay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John Goldingay")]), _vm._v(" is David Allan Hubbard Professor Emeritus of Old Testament at Fuller Seminary.   ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kNhMJ4/tc-custom/9781467462983.jpg?1730410163243",
      "alt": "This image is the cover for the book Proverbs, Commentaries for Christian Formation (CCF)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Proverbs, Commentaries for Christian Formation (CCF)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("What Proverbs meant to its original audience—and what it means to Christians today")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" On one hand, Proverbs is perfectly straightforward—a collection of short statements on how to live wisely and well. On the other, the advice of Proverbs, written millennia ago, can seem disconnected from the realities of life today.  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" John Goldingay’s fresh commentary untangles Proverbs with an eye toward Christian formation. Working from his acclaimed English translation, Goldingay explains each verse in its original context without getting bogged down in technical detail. The commentary centers theological insights beneficial to preaching and pastoral work.  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The wisdom of Proverbs can’t be reduced to platitudes. It requires something of the reader: thought, reflection, and openness to the Lord. The Commentaries for Christian Formation "), _c('i', [_vm._v("Proverbs ")]), _vm._v("guides us in the journey of faith seeking understanding. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0